import { render, staticRenderFns } from "./SelectedProductItem.vue?vue&type=template&id=300a7642&scoped=true"
import script from "./SelectedProductItem.vue?vue&type=script&lang=js"
export * from "./SelectedProductItem.vue?vue&type=script&lang=js"
import style0 from "./SelectedProductItem.vue?vue&type=style&index=0&id=300a7642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300a7642",
  null
  
)

export default component.exports